<template>
    <div class="animated fadeIn">
        <div class="kgr-row kgr-text--rightAligned">
            <button
                class="kgr-button kgr-button--accent"
                @click="openCreateDialog"
            >
                {{ $t('Neue Kategorie anlegen') }}
            </button>
        </div>
        <table class="kgr-table kgr-table--block kgr-table--striped printable">
            <thead>
                <tr class="kgr-table__row">
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Name') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('zu zahlen') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline kgr-table__cell--actions kgr-hidden-print"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-if="loading">
                    <td
                        colspan="4"
                        style="text-align: center;"
                    >
                        <kgr-loader />
                    </td>
                </tr>
                <tr v-else-if="feeCategories.length === 0">
                    <td
                        colspan="4"
                        style="text-align: center;"
                    >
                        {{ $t('dataTable.noData') }}
                    </td>
                </tr>
                <template v-else>
                    <tr
                        v-for="category in feeCategories"
                        :key="category.id"
                        class="kgr-table__row"
                    >
                        <td class="kgr-table__cell">
                            {{ category.name }}
                        </td>
                        <td class="kgr-table__cell">
                            {{ $t(`club.accounting.feeCategory.paymentApproach.${category.paymentApproach}`) }}
                        </td>
                        <td class="kgr-table__cell kgr-table__cell--actions kgr-hidden-print">
                            <button
                                class="kgr-table__action"
                                @click="openEditDialog(category.id)"
                            >
                                <kgr-icon-edit size="15" />
                            </button>
                            <button
                                class="kgr-table__action"
                                @click="deleteFeeCategory(category.id)"
                            >
                                <kgr-icon-delete />
                            </button>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
        <kgr-lightbox
            v-if="modalFeeCategory"
            :headline="modalFeeCategory.id ? modalFeeCategory.name : tCrateNewCategory"
            :value="showDialog"
            animated
            @post-input="closeModal"
        >
            <div>
                <kgr-form-row
                    :label="$t('Name')"
                    :error="error"
                    field-name="name"
                >
                    <kgr-text-input v-model="modalFeeCategory.name" />
                </kgr-form-row>
                <kgr-form-row
                    :label="$t('zu zahlen')"
                    :error="error"
                    field-name="paymentApproach"
                >
                    <kgr-generic-select
                        v-model="modalFeeCategory.paymentApproach"
                        :options="paymentApproachOptions"
                        no-null-option
                        display="name"
                    />
                </kgr-form-row>
                <hr class="kgr-separator--light" />
                <div class="kgr-row">
                    <button
                        class="kgr-button"
                        @click="closeModal()"
                    >
                        {{ $t('cancel') }}
                    </button>
                    <button
                        class="kgr-button kgr-button--accent"
                        @click="modalFeeCategory.id ? updateFeeCategory() : createFeeCategory()"
                    >
                        {{ $t('save') }}
                    </button>
                </div>
            </div>
        </kgr-lightbox>
    </div>
</template>

<script>
import Error from '../../../js/model/Error.js';
import FormRow from '../../../components/common/form/FormRow.vue';
import GenericSelect from '../../../components/common/form/select/GenericSelect.vue';
import IconDelete from '../../../components/common/icon/IconDelete.vue';
import IconEdit from '../../../components/common/icon/IconEdit.vue';
import Lightbox from '../../../components/common/modal/Lightbox.vue';
import Loading from '../../../components/common/Loading.vue';
import TextInput from '../../../components/common/form/input/TextInput.vue';
import axios from 'axios';

export default {
    components: {
        'kgr-icon-delete': IconDelete,
        'kgr-icon-edit': IconEdit,
        'kgr-loader': Loading,
        'kgr-lightbox': Lightbox,
        'kgr-form-row': FormRow,
        'kgr-text-input': TextInput,
        'kgr-generic-select': GenericSelect,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            error: new Error(),
            loading: false,
            showDialog: false,
            feeCategories: [],
            modalFeeCategory: null,
            paymentApproachOptions: [
                { name: this.$t('vorschüssig'), value: 'in_advance' },
                { name: this.$t('nachschüssig'), value: 'in_arrears' },
            ],
        };
    },
    computed: {
        tCrateNewCategory() {
            return this.$t('Neue Kategorie anlegen');
        },

    },
    created() {
        this.loadFeeCategories();
    },
    methods: {
        loadFeeCategories() {
            this.loading = true;
            axios
                .get(`/club/clubs/${this.clubId}/fee-categories`)
                .then((response) => {
                    this.feeCategories = response.data.data;
                    this.loading = false;
                })
                .catch(() => this.$notify.error('error.loadingData'))
                .finally(() => this.loading = false);
        },
        createFeeCategory() {
            axios
                .post(`/club/clubs/${this.clubId}/fee-categories`, {
                    name: this.modalFeeCategory.name,
                    paymentApproach: this.modalFeeCategory.paymentApproach.value,
                })
                .then(() => {
                    this.closeModal();
                    this.loadFeeCategories();
                })
                .catch((error) => {
                    this.error = Error.fromResponse(error.response);
                    this.$notify.error('saveChanges.error');
                })
                .finally(() => this.loading = false);
        },
        deleteFeeCategory(id) {
            showConfirm(this.$t('confirmInformal'), this.$t('Willst du die Kategorie wirklich löschen?'), () => {
                axios
                    .delete(`/club/fee-categories/${id}`)
                    .then(() => {
                        this.loadFeeCategories();
                        this.$notify.success('Die Kategorie wurde erfolgreich gelöscht.');
                    })
                    .catch((error) => {
                        this.error = Error.fromResponse(error.response);
                        this.$notify.error('Die Kategorie konnte nicht gelöscht werden.');
                    });
            }, this.$t('Löschen'));
        },
        updateFeeCategory() {
            axios
                .put(`/club/fee-categories/${this.modalFeeCategory.id}`, {
                    name: this.modalFeeCategory.name,
                    paymentApproach: this.modalFeeCategory.paymentApproach.value,
                })
                .then(() => {
                    this.closeModal();
                    this.loadFeeCategories();
                })
                .catch(() => this.loading = false);
        },
        openEditDialog(id) {
            const feeCategory = this.feeCategories.find((feeCategory) => feeCategory.id === id);
            this.modalFeeCategory = {
                ...feeCategory,
                paymentApproach: this.paymentApproachOptions.find((opt) => opt.value === feeCategory.paymentApproach),
            };
            this.showDialog = true;
        },
        openCreateDialog() {
            this.modalFeeCategory = {
                name: '',
                paymentApproach: this.paymentApproachOptions[0],
            };

            this.showDialog = true;
        },
        closeModal() {
            this.showDialog = false;
            this.modalFeeCategory = null;
        },
    },
};
</script>
